import React from "react";
import {Chart, Axis, Geom, Tooltip, Legend} from "bizcharts";
import DataSet from '@antv/data-set';

const ChartView = ({stages}) => {
    console.log(stages)
    let ft_type = 'petrol';
    let rpmList = ["0", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000"];
    if (stages.length > 0) {
        try {
            const engine = stages[0].parent;
            if (engine.rpm_values) {
                const hp_percentage = engine.my_data != null ? engine.my_data.hp_percentage : engine.hp_percentage
                const nm_percentage = engine.my_data != null ? engine.my_data.nm_percentage : engine.nm_percentage
                const rpmExp = engine.rpm_values.split(',')
                const ftHpExp = hp_percentage.split(',')
                const ftNmExp = nm_percentage.split(',')

                rpmList = rpmExp;
                ft_type = {hp: ftHpExp, nm: ftNmExp}
            } else {
                switch (engine.int_fuel_type) {
                    case 0:
                        rpmList = ["0", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000"];
                        ft_type = {hp: [0, 7, 25, 43, 57, 73, 90, 100, 0], nm: [0, 46, 79, 91, 91, 95, 100, 90, 0]}
                        break
                    case 1:
                        ft_type = {hp: [0, 7, 25, 43, 57, 73, 90, 100, 0], nm: [0, 46, 79, 91, 91, 95, 100, 90, 0]}
                        rpmList = ["0", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000"];
                        break
                    case 2:
                        ft_type = {hp: [0, 16, 45, 63, 80, 90, 97, 100, 90, 0], nm: [0, 50, 90, 99, 100, 95, 85, 79, 67, 0]}
                        rpmList = ["0", "1000", "1500", "2000", "2500", "3000", "3500", "4000", "4500", "5000"];
                        break
                }
            }

            let rpmData = [];
            let stageValue = []
            let rpmStage = [];
            let s_ecod = []
            let sd_1 = []
            let sd_2 = []
            let sd_3 = []
            let sd_4 = []
            let sd_5 = []
            let s_econ = []
            let sn_1 = []
            let sn_2 = []
            let sn_3 = []
            let sn_4 = []
            let sn_5 = []

            rpmList.map((rpml, key) => {
                stages.map((stage) => {
                    const nm = stage.my_data != null ? stage.my_data.nm : stage.int_nm_new;
                    const hp = stage.my_data != null ? stage.my_data.hp : stage.int_hp_new;
                    const hp_org = engine.my_data != null ? engine.my_data.hp : engine.int_hp;
                    const hp_nm = engine.my_data != null ? engine.my_data.nm : engine.int_nm;

                    switch (stage.stage_type) {
                        case 0:
                            stageValue.push([
                                'HP', 'NM'
                            ])
                            s_ecod.push(ft_type.hp[key] * hp_org / 100)
                            s_econ.push(ft_type.nm[key] * hp_nm / 100)

                            break
                        case 1:
                            stageValue.push([
                                'S_1_HP', 'S_1_NM'
                            ])
                            sd_1.push(ft_type.hp[key] * hp / 100)
                            sn_1.push(ft_type.nm[key] * nm / 100)
                            break
                        case 2:
                            stageValue.push([
                                'S_2_HP', 'S_2_NM'
                            ])
                            sd_2.push(ft_type.hp[key] * hp / 100)
                            sn_2.push(ft_type.nm[key] * nm / 100)
                            break
                        case 3:
                            stageValue.push([
                                'S_3_HP', 'S_3_NM'
                            ])
                            sd_3.push(ft_type.hp[key] * hp / 100)
                            sn_3.push(ft_type.nm[key] * nm / 100)
                            break
                        case 4:
                            stageValue.push([
                                'S_4_HP', 'S_4_NM'
                            ])
                            sd_4.push(ft_type.hp[key] * hp / 100)
                            sn_4.push(ft_type.nm[key] * nm / 100)
                            break
                        case 5:
                            stageValue.push([
                                'S_5_HP', 'S_5_NM'
                            ])
                            sd_5.push(ft_type.hp[key] * hp / 100)
                            sn_5.push(ft_type.nm[key] * nm / 100)
                            break
                    }
                })
                rpmStage = {
                    HP: s_ecod[key],
                    S_1_HP: sd_1[key],
                    S_2_HP: sd_2[key],
                    S_3_HP: sd_3[key],
                    S_4_HP: sd_4[key],
                    S_5_HP: sd_5[key],
                    NM: s_econ[key],
                    S_1_NM: sn_1[key],
                    S_2_NM: sn_2[key],
                    S_3_NM: sn_3[key],
                    S_4_NM: sn_4[key],
                    S_5_NM: sn_5[key]
                }
                rpmData.push({
                        rpm: rpml,
                        HP: rpmStage.HP,
                        NM: rpmStage.NM,
                        S_1_HP: rpmStage.S_1_HP,
                        S_1_NM: rpmStage.S_1_NM,
                        S_2_HP: rpmStage.S_2_HP,
                        S_2_NM: rpmStage.S_2_NM,
                        S_3_HP: rpmStage.S_3_HP,
                        S_3_NM: rpmStage.S_3_NM,
                        S_4_HP: rpmStage.S_4_HP,
                        S_4_NM: rpmStage.S_4_NM,
                        S_5_HP: rpmStage.S_5_HP,
                        S_5_NM: rpmStage.S_5_NM,

                    }
                )
            })
            stageValue = stageValue.flat()
            stageValue = stageValue.filter((x, i, a) => a.indexOf(x) == i)
            const ds = new DataSet();
            const dv = ds.createView().source(rpmData);
            dv.transform({
                type: 'fold',
                fields: stageValue, // 展开字段集
                key: 'city', // key字段
                value: 'hp', // value字段
            });
            const cols = {
                rpm: {
                    range: [0, 1]
                }
            }
            return (
                <Chart height={400} data={dv} scale={cols} forceFit>
                    <Legend/>
                    <Axis name="rpm"/>
                    <Axis name="hp" label={{formatter: val => `${val}`}}/>
                    <Tooltip crosshairs={{type: "y"}}/>
                    <Geom type="line" position="rpm*hp" size={2} color={'city'}/>
                    <Geom type='point' position="rpm*hp" size={4} shape={'circle'} color={'city'} style={{stroke: '#fff', lineWidth: 1}}/>

                </Chart>
            )
        } catch (e) {

            return <></>
        }
    } else {
        return <></>
    }

}

export default ChartView;
